import {
  TID_LIST, TID_LIST_SUCCESS, TID_LIST_ERROR, TID_PAGE_SET,
  TID_ADD, TID_ADD_SUCCESS, TID_ADD_ERROR,
  TID_SEARCH_CHANGE,
  TID_FILTER_TASK_STATUS_SUCCESS,
  TID_FILTER_SUPPLIERS_SUCCESS,
  TID_FILTER_DESTINATIONS_SUCCESS
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'idx', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  add: { loading: false, response: '' },
  search: { data: { supplier: '', task_status: '', site_survey_date: '', destination: '' } },
  filters: { task_status: [], suppliers: [], destinations: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TID_LIST: return { ...state, loading: true };
    case TID_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case TID_LIST_ERROR: return { ...state, loading: false, error: true };
    case TID_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case TID_ADD: return { ...state, add: { loading: true, response: '' } };
    case TID_ADD_SUCCESS: return { ...state, add: { loading: false, response: 'success' } };
    case TID_ADD_ERROR: return { ...state, add: { loading: false, response: 'error' } };
    case TID_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };
    case TID_FILTER_TASK_STATUS_SUCCESS: return { ...state, filters: { ...state.filters, task_status: action.payload } };
    case TID_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    case TID_FILTER_DESTINATIONS_SUCCESS: return { ...state, filters: { ...state.filters, destinations: action.payload } };
    default: return { ...state };
  }
};
